//
// Site JS
//

// Vendor - Import Cookie Consent
import 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';

// Vendor - Sal (scroll animations)
import sal from 'sal.js';
import 'sal.js/dist/sal.css';

// Initialize Cookie Consent
if (!document.getElementById('cc-main')) {
    window.cc = window.initCookieConsent();
    window.cc.run({
        current_lang: 'en',
        autoclear_cookies: true,                   // default: false
        page_scripts: true,                        // default: false

        languages: {
            'en': {
                consent_modal: {
                    title: 'This website uses cookies',
                    description: 'We use cookies on our site to improve your experience and analyse usage. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
                    primary_btn: {
                        text: 'Accept all',
                        role: 'accept_all'              // 'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text: 'Reject all',
                        role: 'accept_necessary'        // 'settings' or 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: 'Cookie preferences',
                    save_settings_btn: 'Save settings',
                    accept_all_btn: 'Accept all',
                    reject_all_btn: 'Reject all',
                    close_btn_label: 'Close',
                    cookie_table_headers: [
                        { col1: 'Name' },
                        { col2: 'Domain' },
                        { col3: 'Expiration' },
                        { col4: 'Description' }
                    ],
                    blocks: [
                        {
                            title: 'Cookies',
                            description: 'You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="/privacy" class="cc-link">privacy policy</a>.'
                        }, {
                            title: 'Strictly necessary cookies',
                            description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                            },
                            cookie_table: [
                                {
                                    col1: 'cc_cookie',
                                    col2: location.hostname,
                                    col3: '182 days',
                                    col4: 'Used to remember your cookie preferences.',
                                },
                                {
                                    col1: 'CraftSessionId',
                                    col2: location.hostname,
                                    col3: 'Session',
                                    col4: 'Used to persist session state.',
                                },
                                {
                                    col1: 'CRAFT_CSRF_TOKEN',
                                    col2: location.hostname,
                                    col3: 'Session',
                                    col4: 'Used to protect against CSRF attacks.',
                                },
                                {
                                    col1: '*_identity',
                                    col2: location.hostname,
                                    col3: 'While logged in',
                                    col4: 'Used to maintain a secure, authenticated session.',
                                },
                                {
                                    col1: '*_username',
                                    col2: location.hostname,
                                    col3: '1 year',
                                    col4: 'Used to remember your username when logging in.',
                                },
                            ]
                        }, {
                            title: 'Performance and Analytics cookies',
                            description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
                            toggle: {
                                value: 'analytics',     // your cookie category
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: '^_ga',       // match all cookies starting with "_ga"
                                    col2: 'google.com',
                                    col3: '2 years',
                                    col4: 'Used to distinguish users.',
                                    is_regex: true
                                },
                                {
                                    col1: '_ga_RJ50K6K7HN',
                                    col2: 'google.com',
                                    col3: '2 years',
                                    col4: 'Used to persist session state.',
                                }
                            ]
                        }, {
                            title: 'More information',
                            description: 'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="/contact">contact us</a>.',
                        }
                    ]
                }
            }
        }
    });
}

// Initialize Sal
sal();

// Update Sal for pages with AJAX content (Sprig)
window.addEventListener('htmx:afterSwap', function (event) {
    const scrollAnimations = sal();
    scrollAnimations.update();
});

// Check if JS is enabled in browser, if so the `no-js` class is removed from <body>
document.body.classList.remove('no-js');

// Menu toggle (used for navigation in .site-header)
// Define menu elements
const menuToggle = document.querySelector('#js-menu-toggle');
const menuContainer = document.querySelector('#js-menu-container');

// Listen for click events
document.addEventListener('click', function (event) {

    // Check if clicked element is the toggle
    if (event.target !== menuToggle) return;

    // If so, change ARIA and toggle classes used to reveal
    const open = JSON.parse(menuToggle.getAttribute('aria-expanded'));
    menuToggle.setAttribute('aria-expanded', !open);
    menuToggle.classList.toggle('js-menu-toggle--active');
    menuContainer.classList.toggle('js-menu-container--open');

}, false);

// Once page is loaded
document.addEventListener('DOMContentLoaded', function () {

    // Remove .preload class
    document.body.classList.remove('preload');

    // Check for accordions
    (function () {
        const headings = document.querySelectorAll('.js-accordion');

        Array.prototype.forEach.call(headings, h => {
            let btn = h.querySelector('button');
            let target = h.nextElementSibling;

            btn.onclick = () => {
                let expanded = btn.getAttribute('aria-expanded') === 'true';

                btn.setAttribute('aria-expanded', !expanded);
                target.hidden = expanded;
            }
        });
    })()

}, false);